// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__ZdHi_","text":"SelectPayment_text__HPaLh","title":"SelectPayment_title__2vA0n","btn":"SelectPayment_btn__1Ye0C"};